import React from "react"
import PropTypes from "prop-types"

import RouterLink from "@irati/ui/src/Link/RouterLink"
import {FormattedMessage} from "@irati/utils/lang"

import sitemap from "../../routes/sitemap"

const NotificationLink = ({context, remove}) => (
  <RouterLink app={context.appPath} onClick={remove} to={sitemap.reports.url} plain>
    <FormattedMessage id="insights.reports.notification.link.text" />
  </RouterLink>
)


NotificationLink.propTypes = {
  context: PropTypes.object,
  remove: PropTypes.func.isRequired
}

NotificationLink.defaultProps = {
  context: {}
}
export default NotificationLink
